// @flow
export { default } from './SecurityBadge';
